import WhoWeAre from './WhoWeAre.jsx';

export default WhoWeAre;
